/**
 * Created by mqamhieh on 5/9/18.
 */

(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("userServices", UserServicesService);

    UserServicesService.$inject = ['$q', 'brandServices', 'hUser'];

    function UserServicesService ($q, brandServices, hUser) {
        var self = this;
        var cachedBrandServices = {};

        var ACTIVE_SERVICE = "ACTIVE";
        var PASS_SERVICE = "PASS";

        self.SERVICES = brandServices.SERVICES;

        var servicesBuffer = new hBuffer($q);

        servicesBuffer
            .filterIds(function (brandIds) {
                var filtered = [];

                for (var i in brandIds) {
                    if (!cachedBrandServices[brandIds[i]]) {
                        filtered.push(brandIds[i]);
                    }
                }

                return filtered;
            })
            .doAsync(function (brandIds) {
                var defer = $q.defer();

                BrandAPI.getBrandServicesAsObjects(brandIds)
                    .then(function (res) {
                        defer.resolve(res);
                    }, function (err) {
                        console.error(err);
                        defer.reject(err);
                    });

                return defer.promise;
            })
            .processResult(function (brandAccessData) {

                for (var brandId in brandAccessData) {
                    cachedBrandServices[brandId] = brandAccessData[brandId].services[brandId];
                }
                return brandAccessData;
            });

        var checkService = function (brandId, serviceCode, includePASS) {

            var services = cachedBrandServices[brandId];
            includePASS = includePASS || false;

            if (services && services.length) {
                for (var i = 0; i < services.length; i++) {
                    var service = services[i],
                        checkType = (service.type === ACTIVE_SERVICE || includePASS && service.type === PASS_SERVICE);
                    if (checkType && serviceCode === service.code) {
                        return true;
                    }
                }
            } else {
                console.warn("cachedBrandServices is empty for:", brandId);
            }

            return false;
        };

        self.isServiceEnabled = function (serviceCode, brandId, includePASS) {

            if(brandId){
                brandId = parseInt(brandId);
            }

            if (!serviceCode) {
                throw "Service code is required, got: " + serviceCode
            }

            includePASS = includePASS || false;

            var defer = $q.defer();

            var user = hUser.data.user;

            if (hUser.isEmployer()) {
                if (!brandId) {
                    if (user.services) {
                        defer.resolve(user.services.indexOf(serviceCode) > -1);
                    }
                    else {
                        defer.resolve(false);
                    }
                }
                else {
                    servicesBuffer.register(brandId)
                        .then(function () {
                            defer.resolve(checkService(brandId, serviceCode, includePASS));
                        });
                }
            }
            else {
                defer.resolve(false);
            }

            return defer.promise;
        };
    }

})();